import { ProductsTabTranslations } from "#i18n/translations/pt-BR/org/products/products-tab";

export const ORG_PRODUCTS_TAB_FR_FR: ProductsTabTranslations = {
	label: "Enregistrement de base de produit",
	description:
		"Liste des produits enregistrés dans l'organisation et leurs informations de base.",
	header: {
		counter: "{{amount}} Produits",
		search: "Rechercher",
		add: "Ajouter un produit",
		inventory: "Modifier l'inventaire",
		export: "Exporter les produits",
		addPlaces: "Ajouter des lieux",
		editPlaces: "Modifier les lieux",
		deleteProduct: "Supprimer (1) produit",
		deleteMultipleProducts: "Supprimer ({{products}}) produits",
	},
	addEditProductModal: {
		add: "Ajouter un produit",
		update: "Mettre à jour le produit",
		edit: "Modifier le produit",
		undefined: "Non défini",
		unavailable: "Non disponible",
		form: {
			name: {
				label: "Nom du produit",
				placeholder: "Entrez un nom pour le produit",
				error: "Utiliser uniquement des caractères valides",
			},
			type: {
				label: "Type",
				placeholder: "Sélectionner un type de produit",
			},
			category: {
				label: "Catégorie",
				info: "Vous allez créer une nouvelle catégorie",
				placeholder: "Sélectionner ou créer une catégorie",
				error: "Choisir ou créer une catégorie",
			},
			code: {
				label: "SKU",
				placeholder: "Entrez un SKU",
				tooltip: "Si non rempli, le code sera généré automatiquement",
				error: "La référence SKU ne peut pas contenir le caractère #",
			},
			ncm: {
				label: "NCM",
				placeholder: "Entrez un NCM",
				error: "Le NCM doit avoir 8 chiffres",
			},
			photo: "Photo",
			hasAlcohol: "Contient-il de l'alcool ?",
			error: "Ce champ est obligatoire",
		},
	},
	inventoryUpdate: {
		label: "Modifier l'inventaire",
		import: "Importer le tableau",
		download: "Télécharger le tableau",
		columns: {
			id: "Id du produit",
			name: "Nom",
			category: "Catégorie",
			type: "Type de produit",
			hasAlcohol: "Contient-il de l'alcool ?",
			fiscalCode: "SKU",
			fiscalNcm: "Fiscal - Ncm",
			systemProductId: "Id Produit du Système",
		},
	},
	exportProducts: {
		products: "Produits",
		warningNotification: "Produits non modifiés",
		columns: {
			id: "Id du produit",
			title: "Nom",
			category: "Catégorie",
			places: "Lieux",
			fiscalNcm: "NCM",
			fiscalCode: "SKU",
			systemProductId: "ID Produit du Système",
			type: "Type",
			hasAlcohol: "Contient-il de l'alcool ?",
			description: "Description",
		},
	},
	productForm: {
		required: "Ce champ est obligatoire",
		alcoholLabel: "Contient-il de l'alcool ?",
		categoryLabel: "Catégorie",
		categoryPlaceholder: "Entrez la catégorie du produit",
		createProduct: "Créer un produit d'inventaire",
		editProduct: "Modifier le produit d'inventaire",
		fiscalCodelabel: "SKU",
		fiscalCodePlacehodler: "Entrez le code SKU du produit",
		fiscalCodeError: "Uniquement des chiffres, des points et des lettres",
		ncmLabel: "NCM",
		ncmPlaceholder: "Entrez le code NCM du produit",
		photolabel: "Photo",
		productNameLabel: "Nom du produit",
		productNamePlaceholder: "Entrez le nom du produit",
		placesLabel: "Lieux",
		placesPlaceholder: "Sélectionnez les lieux du produit",
		price: "Prix",
		priceTooltip:
			"La modification du prix dans ce champ modifie le prix du produit pour tous les lieux associés",
		editPrice: "Modifier le prix",
		saveEditProduct: "Enregistrer les modifications",
		saveProduct: "Enregistrer le produit",
		confirmProductPrice: {
			goBack: "Retour à l'édition",
			confirm: "Confirmer la modification",
			title: "Confirmer l'ajustement",
			description: {
				title: "Voulez-vous confirmer la modification du prix ?",
				subtitle:
					"Les lieux liés auront la nouvelle valeur de <b>{{productValue}}</b> pour le produit " +
					"<b>{{productName}}.</b>",
			},
		},
	},
	validation: {
		systemProduct: {
			required: "Le produit système est obligatoire",
		},
	},
	types: {
		product: "Produit",
		supply: "Intrant",
	},
	rows: {
		products: "Produits",
		type: "Type",
		places: "Lieux",
		noProducts: "Aucun produit",
		fiscalCode: "SKU",
	},
	selectPlaces: {
		label: "Sélectionner les lieux",
		search: "Rechercher les lieux",
	},
	removeProduct: {
		label: "Supprimer le produit",
		title: "Voulez-vous vraiment supprimer le produit ?",
	},
	modalDelete: {
		title: "Supprimer le produit",
		description:
			"En confirmant cette action, vous supprimez définitivement le produit. Voulez-vous continuer ?",
	},
	modalDeleteMultipleProducts: {
		title: "Supprimer les produits",
		description:
			"En supprimant les produits sélectionnés, ils seront supprimés de tous les lieux, " +
			"et cette action ne pourra pas être annulée.",
		confirm: "Voulez-vous vraiment supprimer ?",
	},
	link: "Lien",
	links: "Liens",
	productPlacesModal: {
		title: "Liens du produit",
		description: "Liste des lieux où le produit est présent",
		seePlace: "Voir le lieu",
	},
	pendingDeletion: {
		iconLabel: "Produit en cours de suppression",
		actionDisabled:
			"Ce produit est dans la file d'attente de suppression et ne peut pas être modifié",
		failedReasonPrefix: "Échec de la suppression :",
	},
};
